import React from "react";
import styles from "./PageLayout.module.css";

import Top from "../MainContent/Header/Top/Top";
import SideBanner from "../SideBanner/SideBanner";
import Footer from "../MainContent/Body/Footer/Footer";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, className }) => {
  return (
    <div className={styles.Page}>
      <SideBanner side="left" />

      <main className={styles.Main}>
        <header className={styles.Header}>
          <Top />
          <div className={styles.Border} />
        </header>

        <div className={styles.BodyAndFooter}>
          <section className={`${styles.Body} ${className || ""}`}>
            {children}
          </section>

          <Footer />
        </div>
      </main>

      <SideBanner side="right" />
    </div>
  );
};

export default PageLayout;